import { useTranslation } from "react-i18next";
import ListGroup from "./controls/ListGroup";
import ListGroupObjectItem from "./controls/ListGroupObjectItem";
import Grid from "./layout/Grid";
import Row from "./layout/Row";
import Col from "./layout/Col";
import LongTextValue from "./controls/LongTextValue";
import TextValue from "./controls/TextValue";
import ListValue from "./controls/ListValue";
import MeasureValue from "./controls/MeasureValue";
import { SustanciaQuimicaSchema } from "../data/SustanciaQuimicaSchema";

export function SustanciaQuimicaList({ value, select, remove, disabled }) {
  const { t } = useTranslation();
  return (
    <ListGroup>
      {value.map((sustanciaQuimica, index) => {
        const isInvalid = !SustanciaQuimicaSchema.isValidSync(
          sustanciaQuimica,
          { abortEarly: false },
        );
        const casValue = sustanciaQuimica?.CAS || "FALTA";
        const casClassName = sustanciaQuimica?.CAS ? "" : "text-danger";
        return (
          <ListGroupObjectItem
            key={sustanciaQuimica.orden}
            index={index}
            value={sustanciaQuimica}
            indexLabel={t("sustanciaQuimica.orden")}
            className={isInvalid ? "has-error" : ""}
            deletable={!disabled}
            onDelete={(event) => {
              event.preventDefault();
              remove(index);
            }}
            editable={!disabled}
            onEdit={(event) => {
              event.preventDefault();
              select(index);
              document.getElementById("sustanciasQuimicas").scrollIntoView({
                behavior: "smooth",
                block: "start",
              });
            }}
            disabled={disabled}
          >
            {({ value }) => (
              <Grid>
                <Row>
                  <Col>
                    <LongTextValue
                      label={t("sustanciaQuimica.nombreComercial")}
                      value={value?.nombreComercial}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <LongTextValue
                      label={t("sustanciaQuimica.nombreQuimico")}
                      value={value?.nombreQuimico}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <TextValue
                      className={casClassName}
                      label={t("sustanciaQuimica.CAS")}
                      value={casValue}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <ListValue
                      label={t("sustanciaQuimica.operacionesUnitarias")}
                      value={value?.operacionesUnitarias}
                      labelAttr="nombre"
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <MeasureValue
                      label={t("sustanciaQuimica.cantidad")}
                      value={value?.cantidad}
                    />
                  </Col>
                </Row>
              </Grid>
            )}
          </ListGroupObjectItem>
        );
      })}
    </ListGroup>
  );
}
